<template>
    <v-dialog :value="true" width="400">
        <v-card>
            <v-card-title class="headline">
                Vyhodit hráče
            </v-card-title>
            <v-card-text>
                <p>Opravdu chcete z týmu vyhodit hráče <b>{{ player.nickname }}</b>?</p>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-btn color="secondary" text @click.stop="onClose">Zrušit</v-btn>
                <v-spacer/>
                <v-btn color="primary" dark :loading="firing" :disabled="firing" @click.stop="onFire">Vyhodit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { FIRE_TEAM_MEMBER_REQUEST } from '../../store/actions/team'

    export default {
        name: 'FireMember',
        props: {
            player: {
                type: Object,
                required: true,
            },
        },
        data () {
            return {
                firing: false,
            };
        },
        methods: {
            onClose () {
                this.$emit('close');
            },
            async onFire () {
                 try {
                     this.firing = true;
                     await this.$store.dispatch('team/' + FIRE_TEAM_MEMBER_REQUEST, { memberId: this.player.id });
                     this.$toast.success('Hráč byl vyhozen z týmu.');
                     this.onClose();
                 } catch (e) {
                     const message = e.response.data.message || 'Při vyhození hráče došlo k chybě.';
                     this.$toast.error(message);
                 } finally {
                     this.firing = false;
                 }
            },
        },
    }
</script>
